define('model/person.model',['require','exports','module','fukit'],function(require, exports, module) {
  var PersonModel = require('fukit').PersonModel;

  PersonModel.PersonDetailModel = PersonModel.extend({
    virtual: {},
    // COI-2142: new person finder at coi-service-v2 instead of deprecated datagator
    //urlRoot: '/api/v1/iacuc-aggregator/person',
    urlRoot: '/api/v2/coi/personFinder/persons',
  });

  PersonModel.PersonDetailModel.ActiveCollection = PersonModel.PersonDetailModel.Collection.extend({
    filters: [
      {
        field: 'active',
        value: true,
      },
    ],
  });

  PersonModel.PersonDetailModel.WithUserCollection = PersonModel.PersonDetailModel.Collection.extend({
    filters: [
      {
        field: 'userAccountId',
        operation: '^',
        value: 'null',
      },
    ],
  });

  module.exports = PersonModel;
});

